import { colors } from '../../../shared/theme/colors'
import { spacing } from '../../../shared/theme/spacing'
import { ticketColors, ticketFonts } from '../../../shared/theme/ticketColors';

export const posCartParkStyleDefs = {
  cartHeaderParkBtn: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 6,
      borderRadius: 10,
      borderWidth: 1,
      borderColor: ticketColors.ruleSoft,
      backgroundColor: ticketColors.paper2,
      paddingVertical: 8,
      paddingHorizontal: 10,
      minHeight: 36,
    },

  cartHeaderParkBtnText: {
      color: ticketColors.ink2,
      fontWeight: '600',
      fontSize: 13,
      lineHeight: 16,
      fontFamily: ticketFonts.sans,
    },

  parkedSaleBarWrap: {
      gap: spacing.xs,
      marginBottom: spacing.xs,
    },

  parkedSaleBanner: {
      flexDirection: 'row',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: spacing.sm,
      borderRadius: 10,
      borderWidth: 1,
      borderColor: ticketColors.ruleSoft,
      backgroundColor: ticketColors.paper2,
      paddingVertical: 10,
      paddingHorizontal: 12,
    },

  parkedSaleBannerTextWrap: {
      flex: 1,
      minWidth: 0,
      gap: 2,
    },

  parkedSaleBannerTitle: {
      color: ticketColors.ink,
      fontWeight: '700',
      fontSize: 13,
      lineHeight: 18,
      letterSpacing: -0.1,
      fontFamily: ticketFonts.sans,
    },

  parkedSaleBannerMeta: {
      color: ticketColors.ink2,
      fontWeight: '500',
      fontSize: 12,
      lineHeight: 16,
      fontFamily: ticketFonts.sans,
    },

  parkedSaleBannerMetaAmt: {
      color: ticketColors.ink,
      fontWeight: '600',
      fontSize: 12,
      lineHeight: 16,
      fontVariant: ['tabular-nums'],
      fontFamily: ticketFonts.mono,
    },

  parkedSaleBannerGhostBtn: {
      width: 36,
      height: 36,
      borderRadius: 10,
      alignItems: 'center',
      justifyContent: 'center',
      borderWidth: 1,
      borderColor: ticketColors.ruleSoft,
      backgroundColor: ticketColors.paper2,
    },

  parkedSaleResumeBtn: {
      minHeight: 36,
      paddingVertical: 8,
      paddingHorizontal: 14,
      borderRadius: 10,
      backgroundColor: ticketColors.gold,
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      flexGrow: 1,
      flexBasis: 120,
    },

  parkedSaleResumeBtnText: {
      color: ticketColors.goldInk,
      fontWeight: '700',
      fontSize: 13,
      lineHeight: 16,
      letterSpacing: -0.1,
      fontFamily: ticketFonts.sans,
      textAlign: 'center',
    },

  parkedSaleConfirmBanner: {
      borderRadius: 10,
      borderWidth: 1,
      borderColor: ticketColors.ruleSoft,
      backgroundColor: ticketColors.paper2,
      paddingVertical: 12,
      paddingHorizontal: 12,
      gap: spacing.sm,
    },

  parkedSaleConfirmText: {
      color: ticketColors.ink,
      fontWeight: '700',
      fontSize: 13,
      lineHeight: 18,
      letterSpacing: -0.1,
      fontFamily: ticketFonts.sans,
    },

  parkedSaleConfirmActions: {
      flexDirection: 'row',
      justifyContent: 'flex-end',
      gap: 8,
    },

  parkedSaleConfirmCancelBtn: {
      minHeight: 36,
      borderRadius: 10,
      borderWidth: 1,
      borderColor: ticketColors.ruleSoft,
      backgroundColor: 'transparent',
      paddingVertical: 8,
      paddingHorizontal: 12,
      alignItems: 'center',
      justifyContent: 'center',
    },

  parkedSaleConfirmCancelText: {
      color: ticketColors.ink2,
      fontWeight: '600',
      fontSize: 13,
      lineHeight: 16,
      fontFamily: ticketFonts.sans,
    },

  parkedSaleConfirmDeleteBtn: {
      minHeight: 36,
      borderRadius: 10,
      backgroundColor: ticketColors.bad,
      paddingVertical: 8,
      paddingHorizontal: 12,
      alignItems: 'center',
      justifyContent: 'center',
    },

  parkedSaleConfirmDeleteText: {
      color: ticketColors.goldInk,
      fontWeight: '700',
      fontSize: 13,
      lineHeight: 16,
      fontFamily: ticketFonts.sans,
    },

  parkedSaleParkButton: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      gap: spacing.xs,
      alignSelf: 'flex-start',
      borderRadius: 10,
      borderWidth: 1,
      borderColor: ticketColors.ruleSoft,
      backgroundColor: ticketColors.paper2,
      paddingVertical: 8,
      paddingHorizontal: 12,
      minHeight: 36,
    },

  parkedSaleParkButtonText: {
      color: ticketColors.ink2,
      fontWeight: '600',
      fontSize: 13,
      lineHeight: 16,
      fontFamily: ticketFonts.sans,
    },
} as const;
